var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import MobxReactForm from 'mobx-react-form';
import { translate, Trans } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import { Icon } from '@bytebrand/fe-ui-core-autobahn/ui';
import ExportSection from './ExportSection';
import Page from '../../containers/Page';
import { plugins, fields } from './formSettings';
import styles from './DataExportPage.styl';
const sections = [
    /*   {
      name: 'autoscout24',
      title: 'AutoScout24',
      form: new MobxReactForm({ fields }, { plugins }),
      logo: <IconSVG name='autoScoutLogo' customDimensions={true}
      className={styles.logo} width='200px' height='100px' />
    },
    */ // TODO: delete comments when API form autoscout24 will be implemented
    {
        name: 'mobilede',
        title: 'mobile.de',
        form: new MobxReactForm({ fields }, { plugins }),
        logo: React.createElement(IconSVG, { name: 'mobiledeLogo', customDimensions: true, className: styles.logo, width: '200px', height: '70px' })
    }
];
let DataExportPage = class DataExportPage extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "fillForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (platform) => {
                const section = sections.find((section) => section.name === platform.platformType);
                if (!section)
                    return;
                fields.forEach((field) => {
                    const fieldName = field.name;
                    section.form.$(fieldName).set(platform[fieldName]);
                });
            }
        });
        Object.defineProperty(this, "updatePlatformList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { profileStore } = this.props;
                return profileStore.getPlatforms()
                    .then((platforms) => {
                    if (profileStore.hasError) {
                        alert('Server error'); // TODO replace for correct notification tooltip when it be ready
                        return;
                    }
                    sections.forEach((section) => section.form.$('id').value && section.form.clear());
                    platforms.forEach((platform) => {
                        this.setState({ [platform.platformType]: platform.status });
                        this.fillForm(platform);
                    });
                });
            }
        });
        Object.defineProperty(this, "getSubmitFormHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, platformType) => () => {
                const { profileStore } = this.props;
                form.submit()
                    .then((form) => {
                    if (!form.isValid)
                        throw new Error('Validation failed');
                    return form.values();
                })
                    .then((values) => {
                    const { id, customerId, username, password, status } = values;
                    return this.state[platformType]
                        ? profileStore.changePlatform(id, { customerId, username, password, status })
                        : profileStore.addPlatform({ customerId, username, password, status, platformType });
                })
                    .then(() => {
                    if (profileStore.hasError) {
                        alert('Server error'); // TODO replace for correct notification tooltip when it be ready
                        return;
                    }
                    this.updatePlatformList();
                });
            }
        });
        Object.defineProperty(this, "getStatusChangeClickHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (configId, status) => () => {
                const { profileStore } = this.props;
                profileStore.changePlatform(configId, { status })
                    .then(() => {
                    if (profileStore.hasError) {
                        alert('Server error'); // TODO replace for correct notification tooltip when it be ready
                        return;
                    }
                    this.updatePlatformList();
                });
            }
        });
        Object.defineProperty(this, "renderExportSections", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                return sections.map((section) => {
                    const { form, name } = section;
                    const configId = form.$('id').value;
                    const status = this.state[section.name];
                    const nextStatus = status === 'export_active_automatic' ? 'export_active_manual' : 'export_active_automatic';
                    return (React.createElement(ExportSection, { t: t, section: section, key: section.name, isDeactivated: status === 'deactivated' || !status, isAutomatic: status === 'export_active_automatic', isManual: status === 'export_active_manual', onFormSubmit: this.getSubmitFormHandler(form, name), onDeactivatedClick: this.getStatusChangeClickHandler(configId, 'deactivated'), onStatusChangeClick: this.getStatusChangeClickHandler(configId, nextStatus) }));
                });
            }
        });
        this.state = {
            autoscout24: null,
            mobilede: null
        };
    }
    componentDidMount() {
        this.updatePlatformList();
    }
    componentWillUnmount() {
        this.props.profileStore.clearPlatforms();
    }
    render() {
        const { t } = this.props;
        const contactIconWidth = 45;
        const contactIconHeight = 35;
        const stepIconSize = 33;
        const stepIconSize2 = 25;
        return (React.createElement(Page, { page: 'DATA_EXPORT' },
            React.createElement("div", { className: `md3 ${styles.DataExportPage}` },
                React.createElement("h1", { className: styles.pageTitle }, t('title')),
                React.createElement("div", { className: styles.flexWrapper },
                    React.createElement("section", { className: styles.paperHalfSize },
                        React.createElement("h2", { className: styles.title }, t('customersSection.title')),
                        React.createElement("span", null, t('customersSection.content'))),
                    React.createElement("section", { className: styles.paperHalfSize },
                        React.createElement("h2", { className: styles.title }, t('questionsSection.title')),
                        React.createElement("span", null, t('questionsSection.content')),
                        React.createElement("div", { className: styles.flexWrapper },
                            React.createElement("div", { className: styles.contactItem },
                                React.createElement(Icon, { name: 'phone', size: 34, cls: styles.contactIcon }),
                                React.createElement("div", { className: styles.contactContent },
                                    React.createElement("div", { className: styles.contactTitle }, t('questionsSection.phone')),
                                    React.createElement("div", { className: styles.contactText }, "0800 - 40 30 181"))),
                            React.createElement("div", { className: styles.contactItem },
                                React.createElement(Icon, { name: 'mail', size: 34, cls: styles.contactIcon }),
                                React.createElement("div", { className: styles.contactContent },
                                    React.createElement("div", { className: styles.contactTitle }, t('questionsSection.email')),
                                    React.createElement("div", { className: styles.contactText }, "haendler@auto.de")))))),
                React.createElement("section", { className: styles.paper },
                    React.createElement("h2", { className: styles.titleUnderline }, t('exportSection.title')),
                    React.createElement("div", { className: styles.steps },
                        React.createElement("div", { className: styles.stepItem },
                            React.createElement(Icon, { name: 'key', size: 24 })),
                        React.createElement("div", { className: styles.stepArrow }),
                        React.createElement("div", { className: styles.stepItem },
                            React.createElement(Icon, { name: 'users', size: 24 })),
                        React.createElement("div", { className: styles.stepArrow }),
                        React.createElement("div", { className: styles.stepItem },
                            React.createElement(Icon, { name: 'upload', size: 24 })),
                        React.createElement("div", { className: styles.stepArrow }),
                        React.createElement("div", { className: styles.stepItem },
                            React.createElement(Icon, { name: 'check', size: 24 }))),
                    React.createElement("div", { className: styles.flexWrapper },
                        React.createElement("span", { className: styles.stepDescription }, t('exportSection.step_1')),
                        React.createElement("span", { className: styles.stepDescription }, t('exportSection.step_2')),
                        React.createElement("span", { className: styles.stepDescription }, t('exportSection.step_3')),
                        React.createElement("span", { className: styles.stepDescription }, t('exportSection.step_4'))),
                    React.createElement(Trans, { i18nKey: 'exportSection.content' },
                        React.createElement("div", { className: styles.stepContent },
                            "row1",
                            React.createElement("br", null),
                            "row2"))),
                React.createElement("section", { className: styles.paper },
                    React.createElement("h2", { className: styles.titleUnderline }, t('exportSection.title')),
                    sections.map((section) => {
                        const { form, name } = section;
                        const configId = form.$('id').value;
                        const status = this.state[section.name];
                        const nextStatus = status === 'export_active_automatic' ? 'export_active_manual' : 'export_active_automatic';
                        const props = {
                            t,
                            section,
                            key: section.name,
                            isDeactivated: status === 'deactivated' || !status,
                            isAutomatic: status === 'export_active_automatic',
                            isManual: status === 'export_active_manual',
                            onFormSubmit: this.getSubmitFormHandler(form, name),
                            onDeactivatedClick: this.getStatusChangeClickHandler(configId, 'deactivated'),
                            onStatusChangeClick: this.getStatusChangeClickHandler(configId, nextStatus)
                        };
                        return React.createElement(ExportSection, { ...props });
                    })))));
    }
};
DataExportPage = __decorate([
    inject('authStore', 'profileStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], DataExportPage);
export default translate(['DataExportPage'])(DataExportPage);
